import React, { useContext } from "react";
import { SourceType } from "API/courseware";
import FileIcon from "../../../../../CourseDetail/Courseware/components/FileIcon";
import styles from "./index.module.scss";
import classNames from "classnames";
import ItemStatus from "./components/ItemStatus";
import { isTrue } from "Utils/filter";
import { ChapterContext } from "../../../../store";

interface CoursewareItemProps {
    data: SourceType;
    indent: number;
}

export default function CoursewareItem({ indent, data }: CoursewareItemProps) {
    const { onViewCourseware } = useContext(ChapterContext);

    return (
        <div
            role="button"
            className={classNames(styles.root, styles[`level${indent}`])}
            onClick={() => onViewCourseware(data.id)}>
            <FileIcon ext={data.sourceFileEntity?.fileType || ""} />

            <h1 className={styles.title}>{data.sourceFileEntity?.fileName}</h1>

            <ItemStatus
                status={
                    isTrue(data.studyStatusEntity?.studyStatus)
                        ? "done"
                        : "todo"
                }
            />
        </div>
    );
}
